import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  BottomNavigation as MaterialBottomNavigation,
  BottomNavigationAction,
} from "@mui/material";

import styles from "./BottomNavigation.module.scss";
import { navItems } from "../../../routes/Navigation";

const BottomNavigation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentIndex = navItems(t)?.findIndex(
    (item) => item.path === location.pathname
  );
  const [value, setValue] = useState(currentIndex !== -1 ? currentIndex : 0);

  return (
    <MaterialBottomNavigation
      className={styles.bottomNav}
      showLabels
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
        navigate(navItems(t)?.[newValue].path);
      }}
    >
      {navItems(t)?.map((item, index) => (
        <BottomNavigationAction
          key={index}
          label={item.label}
          icon={item.icon}
        />
      ))}
    </MaterialBottomNavigation>
  );
};

export default BottomNavigation;
